import React from 'react';
import { Table } from 'semantic-ui-react';

// @ts-ignore
import TableActions from 'components/TableActions';
import { PayrollExportId } from 'services/payrollExports/types';

// Global Components
// @ts-ignore
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';

// Components
import TimesheetSubmissionsCreatedBy from './components/TimesheetSubmissionsCreatedBy';
import TimesheetSubmissionsSubmittedAt from './components/TimesheetSubmissionsSubmittedAt';
import TimesheetSubmissionsDownloadLink from '../../../TimesheetSubmissionsDownloadLink';
import TimesheetSubmissionsNumberOfTimesheets from './components/TimesheetSubmissionsNumberOfTimesheets';
import TimesheetSubmissionsRevertLink from './components/TimesheetSubmissionsRevertLink';

interface Props {
    id?: PayrollExportId;
}

export default class TimesheetSubmissionsTableRow extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { id } = this.props;

        if (!id) {
            return null;
        }

        return (
            <Table.Row colSpan="5">
                <Table.Cell>{id}</Table.Cell>
                <Table.Cell>
                    <TimesheetSubmissionsCreatedBy id={id} />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetSubmissionsSubmittedAt id={id} />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetSubmissionsNumberOfTimesheets id={id} />
                </Table.Cell>
                <Table.Cell textAlign="right">
                    <TableActions>
                        <CurrentSeasonInProgressGate>
                            <TimesheetSubmissionsRevertLink id={id} />
                        </CurrentSeasonInProgressGate>
                        <TimesheetSubmissionsDownloadLink id={id} />
                    </TableActions>
                </Table.Cell>
            </Table.Row>
        );
    }
}
